import React, { Component } from 'react';
import { bool, func, object, string } from 'prop-types';

import { connect } from 'react-redux';

import EsmsModal from '../../components/EsmsModal';
import CancelButton from '../../components/CancelButton';
import ConfirmButton from '../../components/ConfirmButton';

import * as BasAgentActions from '../../actions/basAgentActions';

import classes from './UnAssignAgentModal.module.css';

class UnAssignAgentModal extends Component {
    handleUpdate = async () => {
        const updates = {
            serialNumber: ''
        };
        const isUpdated = await this.props.updateBasAgent(this.props.companyInfo.companyId, this.props.agent.id, updates);

        if (isUpdated) this.handleClose();
    }

    handleClose = () => {
        this.props.close();
    }

    render() {
        let {open, title} = this.props;
        const agentName = this.props.agent.name;

        return (
            <EsmsModal
                imgSrc="/assets/images/basAgentIconColor.svg"
                onClose={this.handleClose}
                onRendered={this.resetModal}
                open={open}
                title={title}
            >
                Are you sure you want to unassign the BAS Agent from Agent Configuration: {agentName}?
                <div className={classes.buttonContainer}>
                    <CancelButton cancel={this.handleClose} />
                    <ConfirmButton
                        confirm={this.handleUpdate}
                        label="Unassign"
                        type="button"
                    />
                </div>
            </EsmsModal>
        );
    }
}

UnAssignAgentModal.propTypes = {
    agent: object.isRequired,
    close: func.isRequired,
    open:  bool.isRequired,
    title: string.isRequired
};

const mapStateToProps = state => {
    return {
        companyInfo: state.companyInfo
    };
};

const mapDispatchToProps = {
    ...BasAgentActions
};

export default connect(mapStateToProps, mapDispatchToProps)(UnAssignAgentModal);
